import React, {useCallback} from "react";
import {BroadcastUtils, DataAppType, EnvironmentUtils, ProductData, ProductItem} from "filkersjs-model/dist";
import {useCreation} from "ahooks";
import ItemMediaCarrousel from "src/components/item/ItemMediaCarrousel";
import Body from "src/components/layout/Body";
import "src/css/virtual-window.css";
import {Button} from "reactstrap";
import {AiOutlineShoppingCart} from "react-icons/all";
import {useTranslation} from "react-i18next";
import {VirtualWindowDataResponse} from "src/model/VirtualWindowDataResponse";

export interface ItemDetailsPanelProps {
    data: VirtualWindowDataResponse,
    item: ProductItem,
}

const ProductDetailsPanel = ({data, item}: ItemDetailsPanelProps) => {

    const {t} = useTranslation('virtualWindow');

    const itemData = useCreation<ProductData>(() => {
        if (item === undefined) {
            return undefined;
        }
        return BroadcastUtils.findLocalizedItemData(item);
    }, [item]);

    const itemAppType = useCreation<DataAppType>(() => {
        if (data === undefined || item === undefined) {
            return undefined;
        }
        return data.appTypes[item.dataAppUid];
    }, [data, item])

    const buyButtonHandler = useCallback((event) => {
        event.stopPropagation();
        window.open(`${EnvironmentUtils.getHost()}/api/vw/v1/click/${data.vw.uid}/${data.vw.content.uid}/${item.uid}`, '_blank');
    }, [data, item])

    if (itemData === undefined) {
        return null;
    }

    return (
        <Body>
            <ItemMediaCarrousel item={item} style={{height: "82%"}}/>

            <div className="flk-item-data flk-item-data-large px-2" style={{paddingTop: "3%", height: "18%"}}>

                {itemAppType === DataAppType.Woocommerce || itemAppType === DataAppType.Prestashop ? (
                    <div style={{float: "right"}}>
                        <Button
                            size={"sm"}
                            onClick={buyButtonHandler}
                            style={{backgroundColor: "#2497AE", borderColor: "#2497AE"}}
                        >
                            <AiOutlineShoppingCart/>&nbsp;&nbsp;{t('details.buy')}
                        </Button>
                    </div>
                ) : null}

                <div>
                    <span className="flk-item-data-price">
                        {itemData.price === undefined ? '' : itemData.price.isoformat}
                    </span>
                    <span className="flk-item-data-original-price-wrapper">
                            <span className="flk-item-data-original-price">
                                {itemData.originalPrice === undefined ? '' : itemData.originalPrice.isoformat}
                            </span>
                        </span>
                </div>

                <div>
                    {itemData.title}
                </div>


            </div>
        </Body>
    )
}

export default ProductDetailsPanel;
